export default "__VITE_ASSET__DCH6hoS9__"